var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-grow transition-all duration-300",
      style: { padding: "40px 0px 40px 0px" }
    },
    [
      _c("div", {
        staticClass: "flex-grow flex-shrink transition-all duration-300",
        on: {
          click: function($event) {
            return _vm.$emit("change-focus-id", 0)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 worksheet-container bg-pure-white",
          style: { width: "800px", padding: "40px 0px 40px 0px" }
        },
        [
          _vm.addGraphLoading
            ? _c(
                "div",
                {
                  staticClass:
                    "fixed top-0 left-0 z-20 flex items-center justify-center flex-grow w-full h-full opacity-50 bg-pure-white"
                },
                [_c("div", { staticClass: "blum-loader" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.report.include_header
            ? _c(
                "div",
                {
                  staticClass: "flex items-center justify-between",
                  style: { padding: "12px 40px", gap: "16px" },
                  attrs: { id: "worksheet-header" }
                },
                [
                  _vm.report.center_logo_url
                    ? _c("div", { staticClass: "flex flex-shrink-0" }, [
                        _c("img", {
                          style: { height: "40px" },
                          attrs: {
                            src: _vm.report.center_logo_url,
                            alt: "logo"
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-full text-right truncate" }, [
                    _c(
                      "div",
                      { staticClass: "truncate" },
                      [
                        _c("BlTextBody3", {
                          staticClass: "truncate text-slate-700",
                          attrs: { text: _vm.report.client_name }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlTextBody3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Report for " }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "text-slate-700",
                          attrs: {
                            text: _vm.displayDate({
                              date: _vm.report.start_date
                            })
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "text-slate-700",
                          attrs: { text: " - " }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody3", {
                          staticClass: "text-slate-700",
                          attrs: {
                            text: _vm.displayDate({ date: _vm.report.end_date })
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex items-center justify-center",
              style: { padding: "12px 40px" },
              attrs: { id: "worksheet-title" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "font-bold text-slate-1000",
                  style: { fontSize: "26px" }
                },
                [_vm._v("\n        " + _vm._s(_vm.report.name) + "\n      ")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: { handle: ".handle" },
              on: {
                update: function($event) {
                  return _vm.onMoveSection($event)
                },
                start: function($event) {
                  return _vm.onStartDrag($event)
                },
                end: _vm.onEndDrag
              }
            },
            [
              _c(
                "transition-group",
                _vm._l(_vm.sections, function(section) {
                  return _c(
                    "div",
                    {
                      key: section.id,
                      attrs: {
                        id: "report-section-" + section.id,
                        "data-id": section.id
                      }
                    },
                    [
                      _vm.mode === "edit" || _vm.dragMove
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center rounded",
                              class: [
                                _vm.addTextAreaLoading
                                  ? "cursor-wait"
                                  : "cursor-pointer",
                                _vm.dragMove
                                  ? "hover:bg-light-purple-100"
                                  : "opacity-0 hover:opacity-100"
                              ],
                              style: { padding: "0px 4px", gap: "8px" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddTextArea(section.position)
                                },
                                mouseup: function($event) {
                                  return _vm.onDropGraph(section.position)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "h-0.5 w-full bg-slate-500 rounded"
                              }),
                              _vm._v(" "),
                              _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: { icon: "plus", color: "slate-8" }
                              }),
                              _vm._v(" "),
                              _vm.dragMove
                                ? _c("BlTextBody2", {
                                    staticClass: "flex-shrink-0",
                                    attrs: {
                                      text: "Drop here to add the graph"
                                    }
                                  })
                                : _c("BlTextBody2", {
                                    staticClass: "flex-shrink-0",
                                    attrs: { text: "Add text block" }
                                  }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "h-0.5 w-full bg-slate-500 rounded"
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("SectionItem", {
                        attrs: {
                          "data-id": section.id,
                          section: section,
                          mode: _vm.dragMove ? "dragging" : _vm.mode,
                          isFocused: _vm.sectionFocusedId === section.id,
                          isDragging: _vm.isDragging,
                          isDraggingGraph: _vm.isDraggingGraph
                        },
                        on: {
                          "change-saving": function($event) {
                            return _vm.$emit("change-saving", $event)
                          },
                          "change-focus-id": function($event) {
                            return _vm.$emit("change-focus-id", $event)
                          },
                          "drop-graph": function($event) {
                            return _vm.onDropGraph(section.position)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.mode === "edit" || _vm.dragMove
            ? _c(
                "div",
                {
                  style: { padding: "4px 40px 4px 40px", gap: "8px" },
                  on: {
                    mouseup: function($event) {
                      return _vm.onDropGraph(0)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center rounded hover:bg-white",
                      class: [
                        _vm.addTextAreaLoading
                          ? "cursor-wait"
                          : "cursor-pointer",
                        _vm.dragMove
                          ? "h-32 justify-center border-2 border-light-purple border-dashed"
                          : ""
                      ],
                      style: { padding: "1px 1px", gap: "2px" },
                      on: { click: _vm.onAddTextArea }
                    },
                    [
                      _c("BlIcon", {
                        attrs: { icon: "plus", color: "slate-8" }
                      }),
                      _vm._v(" "),
                      _vm.dragMove
                        ? _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Drop here to add the graph at the end of the report."
                            }
                          })
                        : _c("BlTextBody2", {
                            attrs: { text: "Add text block" }
                          })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "edit"
            ? _c("div", {
                staticClass: "w-full h-32",
                on: {
                  click: function($event) {
                    return _vm.$emit("change-focus-id", 0)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "flex-grow flex-shrink transition-all duration-300",
        on: {
          click: function($event) {
            return _vm.$emit("change-focus-id", 0)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7b8d926", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b8d926","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Editor.vue
// module id = null
// module chunks = 